export default {
  name: 'Apagination',
  props: {
    small: { type: Boolean, default: () => false },
    pages: { type: Object, default: () => ({ page: 1, size: 10 }) },
    pageSizes: { type: Array, default: () => [10, 20, 50, 100] },
    total: { type: Number | String, default: () => 0 },
    prevText: { type: String, default: () => '上页' },
    nextText: { type: String, default: () => '下页' },
    complete: { type: Boolean, default: () => true },
    background: { type: Boolean, default: () => true },
  },
  data() {
    return {
      config: this.pages,
    }
  },
  watch: {
    pages(pages = this.pages) {
      this.config = pages;
    },
  },
  methods: {
    changePage(page) {
      this.config.page = page;
      this.$emit('change', this.config);
      this.$emit('changePage', this.config);
    },
    changeSize(size) {
      this.config.size = size;
      this.$emit('change', this.config);
      this.$emit('changeSize', this.config);
    },
  },
  render() {
    const { width = '100%', padding = '12px 0', margin = '0', align = 'right', ...attrs } = this.$attrs;
    return (
      <el-pagination
        class="a-pagination"
        small={this.small}
        on-current-change={this.changePage}
        on-size-change={this.changeSize}
        current-page={this.config.page}
        page-size={this.config.size}
        page-sizes={this.pageSizes}
        layout={this.complete ? 'total, sizes, prev, pager, next, jumper' : 'prev, pager, next'}
        total={parseInt(this.total)}
        prev-text={this.prevText}
        next-text={this.nextText}
        background={this.background}
        style={{ width, padding, margin, 'text-align': align }}
        {...{ attrs }}
      />
    );
  }
}